export enum FolderActions {
  Create = 1,
  Rename = 2,
  Copy = 3,
  Move = 4,
  Delete = 5,
  PostFile = 6,
}
